// Characters Windows, macOS or Linux reject in a file name, plus control
// characters; everything else is kept as typed, with spaces as underscores.
// eslint-disable-next-line no-control-regex
const UNSAFE = /[/\\:*?"<>|\u0000-\u001f\u007f]+/g;

// File systems cap names at 255 bytes; this keeps the whole name well under.
const MAX_TITLE_BYTES = 150;

const FALLBACK = "report";

const utf8Length = (codePoint: number) =>
  codePoint < 0x80 ? 1 : codePoint < 0x800 ? 2 : codePoint < 0x10000 ? 3 : 4;

const capBytes = (text: string, maxBytes: number) => {
  let bytes = 0;
  let kept = "";
  for (const char of Array.from(text)) {
    bytes += utf8Length(char.codePointAt(0) as number);
    if (bytes > maxBytes) break;
    kept += char;
  }
  return kept;
};

const trimEnds = (text: string) => text.replace(/^[\s._]+|[\s._]+$/g, "");

// A title typed as a file name keeps a single extension.
const PDF_EXTENSION = /\.pdf[\s.]*$/i;

export function reportFileName(title: string): string {
  const cleaned = trimEnds(
    title
      .normalize("NFC")
      .replace(/\s+/g, " ")
      .replace(UNSAFE, "")
      .replace(/ {2,}/g, " ")
      .replace(PDF_EXTENSION, "")
  )
    .replace(/ /g, "_")
    .replace(/_{2,}/g, "_");
  return `${trimEnds(capBytes(cleaned, MAX_TITLE_BYTES)) || FALLBACK}.pdf`;
}
